<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-6">
                <label for="batch_id" class="col-form-label col-form-label-sm">Select Batch <span style="color: red">*</span></label>
                <select v-model="search_data.batch_id" v-validate="'required'" id="batch_id" name="batch_id" class="form-control form-control-sm">
                  <option :value="''" selected>Select Batch</option>
                  <option v-for="(batch, index) in batches" :key="index" :value="batch.id">
                    {{ batch.trade.desc + " | " + "Batch No: " + batch.batch_no}}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Please Select Batch
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-6 custom-search">
                <button class="btn btn-success btn-sm custom-search-button" @click.prevent="search">
                  Search
                </button>
              </div>
            </div>
          </form>
        </b-card>

        <b-card>
          <div class="row mb-2">
            <div class="col-sm-12">
              <div v-if="batch_trainees.total > 0">
                <span class="badge badge-success mr-2">Total Search Data Found: {{ batch_trainees.total }}</span>
                <download-excel
                      class="btn btn-light float-right"
                      :fetch="fetchData"
                      :fields="grade_fields"
                      :before-generate="startDownload"
                      :before-finish="finishDownload"
                      worksheet="All Grades"
                      name="all-exam-grades.xls">
                  <span v-if="loading" class="spinner-border spinner-border-sm text-muted" style="margin-bottom :  2px;"></span>
                  <span style="cursor : pointer;">Download</span>
              </download-excel>
              </div>
            </div>
          </div>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>SL</th>
                <th>Form No</th>
                <th>Name</th>
                <th>Father Name</th>
                <th>Rep. Name</th>
                <th>Rep. Father Name</th>
                <th>Village</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(trainee, index) in batch_trainees.data" :key="index">
                <td>{{ batch_trainees.from + index }}</td>
                <td>{{ trainee.form_no }}</td>
                <td>{{ trainee.name }}</td>
                <td>{{ trainee.father_husband_name }}</td>
                <td>{{ trainee.rep_name }}</td>
                <td>{{ trainee.rep_father_husband_name }}</td>
                <td>{{ trainee.desc }}</td>
                <td>
                  <a  href="javascript:void(0);" class="action-icon" title="Grade" @click.prevent="viewGrade(trainee.trainee_id), $bvModal.show('trainee-exam-grade-view')">
                    <i class="mdi mdi-eye addButton"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
            <h5 v-if="batch_trainees.length === 0"
                class="text-center text-secondary">
              No Data Found
            </h5>
            <div class="float-right">
              <pagination :data="batch_trainees" :limit="2" @pagination-change-page="getResults"></pagination>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <grade-view
        :trainee_grades="trainee_grades"
        :trainee_name="trainee_name">
    </grade-view>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

import gradeView from "./modal/grade-view";

export default {
  page: {
    title: "List Trainee",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, PageHeader, gradeView },
  data() {
    return {
      title: "Search Trainee",
      items: [
        {
          text: "Trainee",
          href: "/"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      batch_trainees: {},
      search_data: {
        batch_id: ''
      },
      villages: [],
      batches: [],
      trainee_grades: [],
      trainee_grade: '',
      trainee_name: '',
      btn_edit: false,
      loading : false,
      grade_fields : {
        "Form No" : "form_no",
        "Name" : "name",
        "Father Name" : "father_husband_name",
        "Rep. Name" : "rep_name",
        "Rep. Father Name" : "rep_father_husband_name",
        "Village" : "village",
        "Pre-test Mark" : "pre_test_mark",
        "Pre-test Grade": "pre_test_grade",
        "Pre-test Date" : "pre_test_exam_date",
        "Final Exam Mark" : "final_mark",
        "Final Exam Grade" : "final_grade",
        "Final Exam Date": "final_exam_date"
      }
    };
  },


  mounted() {
    this.getBatches();
  },
  methods: {
    search() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .post("api/trainee/grade/getTrainee", this.search_data)
            .then(response => {
              if (!response.error) {
                this.batch_trainees = response.data.batch_trainees;
              }
            });
        }
      });
    },
    async fetchData(){
      const response = await http.get('api/trainee/grade/download');
      console.log(response.data)
    //  return response.data.batch_trainees;
    },
    getResults(page = 1) {
      http.post('api/trainee/grade/getTrainee?page=' + page, this.search_data)
              .then(response => {
                this.batch_trainees = response.data.batch_trainees;
              });
    },
    getBatches() {
      http.get("api/batch/trainee/getBatch").then(response => {
        if (!response.error) {
          this.batches = response.data.batches;
        }
      });
    },
    viewGrade(trainee_id){
      http
          .post("api/trainee/grade/list/" + trainee_id)
          .then(response => {
            if (!response.error) {
              this.trainee_grades = response.data.trainee_grades;
              this.trainee_name = response.data.trainee_name;
            }
          });
    },
    startDownload(){
      this.loading = true
    },
    finishDownload(){
      this.loading = false
    }
  },
};
</script>

